import { PropsWithChildren } from "react";
import styles from "./Badge.module.css";

const Badge = ({ children }: PropsWithChildren) => (
  <span className={styles.badge}>{children}</span>
);

export default Badge;
